import React, { useEffect, useState } from "react";
import {
  downloadCSV,
  ModalCsvExportConfirm,
  pencilIcon,
} from "../../Components";
import AddOffer from "./AddOffer";
import { Modal, plusIcon } from "../../Components";
import {
  influencerlistService,
  influencerlistcsvexportService,
} from "../../Services";
import { utils } from "../../Helpers/utils";
import ListEdit from "./ListEdit";
import ShowInfluencerGrid from "./ShowInfluencerGrid";
import ShowInfluencerList from "./ShowInfluencerList";
import { SwitchWithLabel } from "../../Components/AppSwitchWithLabel";
import { ArrowLeft, LayoutGrid, List } from "lucide-react";
import AddMoreInfluencer from "./AddMoreInfluencer";
import InviteCampaigns from "./InviteCampaigns";
import { useSidebar } from "../../Components/ui/sidebarNew";

export default function ShowInfluencer({
  user,
  setShowCart,
  setUpdateProfilePage,
  updateProfilePage,
  setCartItem,
  cartItem,
  selectedInfluencer,
  removeInfFromList,
  setSelectedInfluencer,
  modalDataList,
  setTab,
  setToastList,
  toastList,
  addToast,
  setTabModal,
  tabModal,
  setGoBack,
  tab,
  setSearchParams,
  goBack,
}) {
  const [page, setPage] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const [paginationData, setPaginationData] = useState({});
  const [countOfInf, setCountOfInf] = useState();
  const [listInfluencer, setListInfluencer] = useState([]);
  const [listDetails, setListDetails] = useState({});
  const [csvPreviewDetails, setCsvPreviewDetails] = useState([]);
  const [csvPreviewLoaded, setCsvPreviewLoaded] = useState(false);
  const [showList, setShowList] = useState(false);
  const [modal, setModal] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const { state } = useSidebar();
  const pageSize = 10;
  const fetchData = async (pageNum = 1, append = false) => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await influencerlistService.getAllInfluencerOfList(
        modalDataList.id,
        {
          page: pageNum,
          pageSize,
        }
      );
      console.log("🚀 ~ fetchData ~ res:", res);
      if (res.success === true) {
        setListDetails(res.data.list);
        setListInfluencer((prev) =>
          append
            ? [...prev, ...res.data.influencers.data]
            : res.data.influencers.data
        );
        let paginationObj = utils.createPaginationData(res.data.influencers);
        setPaginationData(paginationObj);
        setCountOfInf(res.data.influencers.total);
        setHasMore(
          res.data.influencers.current_page < res.data.influencers.last_page
        );
        setIsLoaded(true);
      }
    } catch (err) {
      addToast({
        error: true,
        msg: err.message,
        id: `${Date.now()}-${toastList.length}`,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(1, false);
  }, [selectedInfluencer]);

  const loadMore = () => {
    if (hasMore && !loading) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchData(nextPage, true);
    }
  };
  const addOffer = () => {
    setTabModal("addOffer");
  };
  const chkDownloadIsAllowed = async () => {
    try {
      const res = await influencerlistcsvexportService.previewcsv(
        modalDataList.id
      );
      if (res.success === true && res.data) {
        console.log(res.data);
        setCsvPreviewDetails(res.data);
        setCsvPreviewLoaded(true);
        setTabModal("csvExport");
      }
    } catch (err) {
      addToast({
        error: true,
        msg: err.message,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };
  const exportCsvFile = async () => {
    try {
      setTabModal(null);
      const res = await influencerlistcsvexportService.exportcsv(
        modalDataList.id
      );
      if (res.success === true) {
        utils.downloadFile(res, `influencers_export_${Date.now()}.csv`);
      }
    } catch (err) {
      addToast({
        error: true,
        msg: err.message,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };
  return (
    <div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      exit={{ opacity: 0, y: 30 }}
      className="assetsAdd !ml-0"
      style={{ marginLeft: state === "collapsed" ? "28px " : "" }}
    >
      <div className="assetsAdd__form-title !mb-5">
        <div className="campaignsCreate__btns flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-0">
          <div className="campaignsCreate__btns-row downloadcsvdiv flex flex-wrap items-center gap-2 md:gap-3">
            {tab !== "main" && (
              <button
                className="w-7 h-7 rounded-full bg-gray-100 items-center flex justify-center flex-shrink-0"
                style={{ marginBottom: 0 }}
                onClick={() => {
                  setGoBack(!goBack);
                  sessionStorage.removeItem("modalDataList");
                  setSearchParams({});
                  setTab("main");
                  setPage(1);
                }}
              >
                <ArrowLeft color="#6B7280" size={20} className="" />{" "}
              </button>
            )}
            {listDetails.name !== "" && (
              <>
                {isLoaded && (
                  <>
                    <h3 className="big text-base md:text-lg truncate max-w-[120px] md:max-w-none">{listDetails.name}</h3>
                    <div
                      className="flex-shrink-0"
                      onClick={() => {
                        setShowCart(false);
                        setTabModal("edit");
                      }}
                    >
                      {pencilIcon}
                    </div>
                    <div className="flex-shrink-0" onClick={chkDownloadIsAllowed} title="DownloadCSV">
                      {downloadCSV}
                    </div>
                    <button
                      className="button tertiary big !p-0 !mt-1 text-xs md:text-sm whitespace-nowrap"
                      onClick={() => {
                        setModal("moreInfluencers");
                      }}
                    >
                      {plusIcon} <span className="hidden sm:inline">Add More</span> <span className="sm:hidden">Add</span> <span className="hidden md:inline">Influencer</span>
                    </button>
                    <button
                      className="button tertiary big !p-0 !mt-1 text-xs md:text-sm whitespace-nowrap"
                      onClick={() => {
                        setModal("inviteCampaigns");
                      }}
                    >
                      {plusIcon} <span className="hidden md:inline">Invite to Private Campaign</span><span className="md:hidden">Invite</span>
                    </button>
                  </>
                )}
              </>
            )}
          </div>
          <div className="hidden md:flex gap-3"></div>
          <div className="flex gap-2 md:gap-3 flex-wrap items-center justify-start md:justify-end w-full md:w-auto">
            <div className="flex items-center gap-1 bg-gray-100 pr-2 py-2 rounded-xl w-fit">
              <SwitchWithLabel
                id="listView"
                labelRight=""
                className="scale-90"
                checked={showList}
                onCheckedChange={() => setShowList(!showList)}
              />
              <div className="flex items-center">
                {!showList ? (
                  <LayoutGrid
                    className={`w-5 h-5 ${
                      showList ? "text-green-600" : "text-gray-400"
                    } transition-colors`}
                  />
                ) : (
                  <List
                    className={`w-5 h-5 ${
                      !showList ? "text-green-600" : "text-gray-400"
                    } transition-colors`}
                  />
                )}
              </div>
            </div>
            {isLoaded && (
              <button
                className="button primary !rounded-[10px] text-xs md:text-sm px-3 md:px-4"
                onClick={() => addOffer(modalDataList.id)}
              >
                <span className="hidden sm:inline">Add Custom Offer</span>
                <span className="sm:hidden">Add Offer</span>
              </button>
            )}
          </div>
        </div>
      </div>

      <div
        className="!w-full mb-2 "
        style={{
          height: "calc(100vh - 175px)",
          // overflowY: "auto",
          scrollbarWidth: "thin",
          scrollbarColor: "#e5e7eb transparent",
          position: "relative",
          transition: "opacity 0.2s",
        }}
      >
        <>
          <div className="inflist__table searchcontainer showCompleteContainer ">
            {isLoaded && listInfluencer?.length > 0 ? (
              <>
                {showList === true ? (
                  <ShowInfluencerList
                    setCountOfInf={setCountOfInf}
                    toastList={toastList}
                    listInfluencer={listInfluencer}
                    setListInfluencer={setListInfluencer}
                    addToast={addToast}
                    listId={modalDataList.id}
                    setTabModal={setTabModal}
                    setSelectedInfluencer={setSelectedInfluencer}
                    removeInfFromList={removeInfFromList}
                    setUpdateProfilePage={setUpdateProfilePage}
                    updateProfilePage={updateProfilePage}
                    loadMore={loadMore}
                    hasMore={hasMore}
                    loading={loading}
                  />
                ) : (
                  <div
                    className="grid w-full !mb-5"
                    style={{
                      height: "calc(100vh - 175px)",
                      overflowY: "auto",
                      scrollbarWidth: "thin",
                      scrollbarColor: "#e5e7eb transparent",
                      position: "relative",
                      transition: "opacity 0.2s",
                    }}
                    onScroll={(e) => {
                      const { scrollTop, scrollHeight, clientHeight } =
                        e.target;
                      if (
                        scrollHeight - scrollTop <= clientHeight + 100 &&
                        hasMore &&
                        !loading
                      ) {
                        loadMore();
                      }
                    }}
                  >
                    {listInfluencer.map((item, index) => (
                      <ShowInfluencerGrid
                        key={index}
                        setCountOfInf={setCountOfInf}
                        item={item}
                        toastList={toastList}
                        addToast={addToast}
                        listId={modalDataList.id}
                        setTabModal={setTabModal}
                        setSelectedInfluencer={setSelectedInfluencer}
                        removeInfFromList={removeInfFromList}
                        setUpdateProfilePage={setUpdateProfilePage}
                        updateProfilePage={updateProfilePage}
                      />
                    ))}
                    {loading && (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          gridColumn: "1 / -1",
                        }}
                      >
                        Loading more...
                      </div>
                    )}
                  </div>
                )}
              </>
            ) : (
              isLoaded && (
                <div className="showpriceanddetails">
                  <p className="influencerCategory inLeftNotFound">
                    No Influener found in this list.
                  </p>
                </div>
              )
            )}
          </div>
        </>
      </div>
      {tabModal === "edit" && (
        <Modal addClass="modalAsset" close={() => setTabModal(null)}>
          <div className="modal__asset">
            <div className="modal__asset-inner">
              <ListEdit
                setListDetails={setListDetails}
                listDetails={listDetails}
                setTab={setTab}
                setToastList={setToastList}
                toastList={toastList}
                setTabModal={setTabModal}
              />
            </div>
          </div>
        </Modal>
      )}
      {tabModal === "addOffer" && (
        <Modal addClass="modalAsset" close={() => setTabModal(null)}>
          <div className="modal__asset">
            <div className="modal__asset-inner">
              <AddOffer
                user={user}
                setShowCart={setShowCart}
                listInfluencer={listInfluencer}
                cartItem={cartItem}
                setCartItem={setCartItem}
                listDetails={listDetails}
                setTab={setTab}
                setToastList={setToastList}
                toastList={toastList}
                setTabModal={setTabModal}
              />
            </div>
          </div>
        </Modal>
      )}
      {modal === "moreInfluencers" && (
        <AddMoreInfluencer
          open={modal === "moreInfluencers"}
          close={() => setModal(null)}
          listId={modalDataList.id}
          onSuccess={() => {
            fetchData();
            setModal(null);
          }}
        />
      )}
      {modal === "inviteCampaigns" && (
        <InviteCampaigns
          open={modal === "inviteCampaigns"}
          close={() => setModal(null)}
          listId={modalDataList.id}
          listInfluencer={listInfluencer}
          toastList={toastList}
          setToastList={setToastList}
          onSuccess={() => {
            fetchData();
            setModal(null);
          }}
        />
      )}
      {tabModal === "csvExport" && csvPreviewLoaded && (
        <ModalCsvExportConfirm
          exportCsvFile={exportCsvFile}
          csvPreviewDetails={csvPreviewDetails}
          close={() => setTabModal(null)}
        />
      )}
    </div>
  );
}
